import React, { useEffect, useState } from "react";
import "./WebSolutions.scss";
import { useNavigate } from "react-router-dom";

const API = "https://api.ainfotech.com.np";

export default function WebSolutionsShowcase() {
  const navigate = useNavigate();
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);

  const open = (slug) => navigate(`/websolutions/${slug}`);

  useEffect(() => {
    (async () => {
      try {
        const res = await fetch(`${API}/api/websolutions?status=published&page=1&limit=50`);
        const data = await res.json();
        if (!res.ok) throw new Error(data?.error || "Failed to fetch Web Solutions");
        setItems(Array.isArray(data.items) ? data.items : []);
      } catch (e) {
        console.error(e);
        setItems([]);
      } finally {
        setLoading(false);
      }
    })();
  }, []);

  if (loading) {
    return (
      <section className="websolutions-section">
        <div className="container"><div>Loading…</div></div>
      </section>
    );
  }

  return (
    <section className="websolutions-section">
      <div className="container">
        <div className="svc-grid">
          {items.map((svc) => {
            const cover = svc.cover_image ? `${API}${svc.cover_image}` : undefined;
            return (
              <article
                key={svc.id}
                className="svc-card"
                onClick={() => open(svc.slug)}
                onKeyDown={(e) => {
                  if (e.key === "Enter" || e.key === " ") {
                    e.preventDefault();
                    open(svc.slug);
                  }
                }}
                role="button"
                tabIndex={0}
                aria-label={`Open ${svc.title}`}
              >
                <div
                  className="svc-media"
                  style={{ backgroundImage: cover ? `url(${cover})` : undefined }}
                  aria-hidden="true"
                />
                <div className="svc-info">
                  <div className="svc-meta" role="heading" aria-level={3}>
                    <h3 className="svc-name">{svc.title}</h3>
                  </div>
                  <p className="svc-text">{svc.excerpt || ""}</p>
                  <button
                    className="svc-read"
                    type="button"
                    onClick={(e) => {
                      e.stopPropagation();
                      open(svc.slug);
                    }}
                  >
                    <span className="pipe" aria-hidden="true">|</span> READ MORE
                  </button>
                </div>
              </article>
            );
          })}
          {items.length === 0 && <div>No items found.</div>}
        </div>
      </div>
    </section>
  );
}
